import React, { useEffect, useState, useRef } from "react";
import {
  Modal,
  FormControl,
  Button,
  InputGroup,
} from "react-bootstrap";
import PropTypes from "prop-types";
import ReCAPTCHA from "react-google-recaptcha";
import "./Step.css";
import "../../assets/css/component.css";
import "../../assets/css/modal.css";
import close from "../../assets/svgs/close.svg";
import { useForm } from "react-hook-form";
import { loginUser } from "../../actions/authActions";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import ResetPassword from "./ResetPassword";
import axios from "axios";
import setAuthToken from "../../utils/setAuthToken";
import { setCurrentUser } from "../../actions/authActions";
import MenuModal from "../Menu/MenuModal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Step3 = (props) => {
  const { register, handleSubmit } = useForm();
  const [isResetPassword, setResetPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [captchaError, setcaptchaError] = useState("");
  const [showMenu, setShowMenu] = useState(false);
  const [isSending, setSending] = useState(false);
  const [otpTimer, setOtpTimer] = useState(60);
  const [otpSent, setOtpSent] = useState(false);
  const [alert, setAlert] = useState({ message: "", type: "" });
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const recaptchaRef = useRef(null);

  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (props.auth?.user?.error === "Please enter correct password") {
      setErrorMsg("Password is incorrect. Please try again.");
      localStorage.clear();
      props.auth.isAuthenticated = false;
    } else {
      setErrorMsg("");
    }
  }, [props.auth]);

  const handleCaptchaChange = (token) => {
    if (token) {
      setCaptchaVerified(true);
    } else {
      setCaptchaVerified(false);
    }
  };

  useEffect(() => {
    if (captchaVerified) {
      setcaptchaError("");
    }
  }, [captchaVerified]);

  const onSubmit = async (data) => {
    if (!captchaVerified) {
      setcaptchaError("Please verify the reCAPTCHA before login.");
      return;
    }

    let olddata = { ...props.signInVal, ...data };

    const hasOTP = data.otp && data.otp.trim() !== "";
    const hasPassword = data.password && data.password.trim() !== "";

    if (!hasOTP && !hasPassword) {
      setErrorMsg("Please enter OTP or Password to continue.");
      return;
    }

    if (hasOTP) {
      const payload = {
        contact_number:
          props?.user?.country_code_value + props?.user?.partial_number,
        otp: data.otp,
        business_id: localStorage.getItem("business_id"),
        location_id: localStorage.getItem("location_id"),
        country_code: props?.user?.country_code_value,
      };

      try {
        const res = await axios.post("/auth/verify_otp", payload, {
          headers: { "Content-Type": "application/json" },
        });

        const result = res.data;
        if (result && result.user.access_token) {
          const userData = {
            id: result.user.id,
            username: result.user.username,
            email: result.user.email,
            fname: result.user.first_name,
            lname: result.user.last_name,
            surname: result.user.surname,
            dob: result.user.dob,
            gender: result.user.gender,
            contact_id: result.user.contact_id,
            contactNo: result.user.contact_number,
            address: result.user.address_line_1,
            city: result.user.city,
            zip: result.user.zip_code,
            country: result.user.country,
            user_id: result.user.id,
          };

          const returnData = {
            data: {
              user: userData,
              token: result.user.access_token,
              token_expired_at: result.user.expires_at,
            },
          };

          localStorage.setItem("headers", JSON.stringify(returnData));
          setAuthToken(`Bearer ${result.user.access_token}`);
          props.setCurrentUser(returnData);

          olddata.is_otp_verified = true;
          props.loginClicked(olddata);
        } else {
          setErrorMsg(result.message || "OTP verification failed");
        }
      } catch (error) {
        console.error("Error verifying OTP:", error.response?.data || error.message);
        setErrorMsg("OTP verification failed. Please try again.");
      }
      return;
    }

    if (hasPassword) {
      olddata.is_otp_verified = false;
      props.loginClicked(olddata);
      return;
    }
  };

  const sendMobileOTP = async () => {
    if (!captchaVerified) {
      toast.error("Please verify the reCAPTCHA before sending OTP.");
      return;
    }

    try {
      const payload = {
        contact_number:
          props?.user?.country_code_value + props?.user?.partial_number,
        business_id: localStorage.getItem("business_id"),
        country_code: props?.user?.country_code_value,
      };

      setSending(true);
      const response = await axios.post("auth/request_otp", payload, {
        headers: { "Content-Type": "application/json" },
      });

      const data = response.data;
      setSending(false);

      if (data.success) {
        toast.success("OTP has been sent, you will receive it shortly.");

        setTimeout(() => setAlert(null), 3000);
        setOtpSent(true);
        setOtpTimer(60);

        const timerInterval = setInterval(() => {
          setOtpTimer((prev) => prev - 1);
        }, 1000);

        setTimeout(() => {
          clearInterval(timerInterval);
          setOtpSent(false);
        }, 60000);
      } else {
        setAlert({
          message: data?.message || "Something went wrong, please try again.",
          type: "error",
        });
      }
    } catch (error) {
      setSending(false);
      setAlert({
        message:
          error.response?.data?.message ||
          "Failed to send OTP. Please try again later.",
        type: "error",
      });
      setTimeout(() => setAlert(null), 3000);
    }
  };

  return (
    <Modal
      show={props.show}
      onHide={props.closeModal}
      dialogClassName="modal-md xs"
      contentClassName="xs"
      centered
    >
      <MenuModal show={showMenu} closeModal={() => setShowMenu(false)} />

      <form onSubmit={handleSubmit(onSubmit)}>
        {alert?.message && (
          <div
            style={{
              background: alert.type === "error" ? "#dc3545" : "#1E9D42",
              color: "#fff",
              padding: "12px 10px",
              borderRadius: "4px",
              margin: "20px",
            }}
          >
            <span>{alert.message}</span>
          </div>
        )}

        <Modal.Body className="px-5 py-4">
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={props.closeModal}
          >
            <img src={close} width="20" alt="close" />
          </button>

          <div className="text-center mt-5">
            <div className="back-heading">Good to have you back!</div>
            <div className="warley-description">
              Special deals waiting for you!
            </div>

            <div md={6} style={{ marginTop: "20px" }}>
              <div className="input-title mb-2">Enter OTP</div>
              <InputGroup>
                <FormControl
                  minLength={3}
                  type="text"
                  autoComplete="off"
                  {...register("otp")}
                  placeholder="Enter OTP"
                  className="form-control-lg input input-full"
                  style={{
                    padding: "30px 10px",
                    border: 0,
                    borderColor: "#E9ECEF",
                    borderRadius: 0,
                  }}
                  disabled={!otpSent}
                />
                <Button
                  variant="outline-primary otp-button"
                  onClick={sendMobileOTP}
                  disabled={otpSent}
                >
                  {otpSent ? `Resend in ${otpTimer}s` : "Send OTP"}
                </Button>
              </InputGroup>
              {/* Show OTP-related error message right below the Send OTP field */}
              {errorMsg && errorMsg.toLowerCase().includes('otp') && (
                <div className="text-danger mt-2" role="alert">{errorMsg}</div>
              )}
            </div>

            <div className="d-flex align-items-center justify-content-center my-4">
              <div style={{ flex: 1, height: "1px", backgroundColor: "#E0E0E0" }}></div>
              <span style={{ margin: "0 12px", fontWeight: "500", color: "#6c757d", fontSize: "14px" }}>or</span>
              <div style={{ flex: 1, height: "1px", backgroundColor: "#E0E0E0" }}></div>
            </div>

            {/* PASSWORD FIELD */}
            <div className="mt-4">
              <div className="input-title mb-2">Password</div>
              <input
                type="password"
                autoComplete="off"
                {...register("password")}
                placeholder=""
                className="form-control-lg input input-full"
              />
            </div>

            {/* Show non-OTP error messages near password area (avoid duplicating OTP messages) */}
            {errorMsg && !errorMsg.toLowerCase().includes('otp') && (
              <div className="text-danger mt-2">{errorMsg}</div>
            )}

            <div
              onClick={() => setResetPassword(true)}
              className="text-left my-3 warley-description"
              style={{ cursor: "pointer" }}
            >
              Reset your password
            </div>

            <div className="my-3 d-flex justify-content-center">
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={handleCaptchaChange}
                ref={recaptchaRef}
              />
            </div>
            {captchaError && <div className="text-danger mt-2">{captchaError}</div>}
          </div>

          <ResetPassword
            data={props.signInVal}
            close={props.closeModal}
            show={isResetPassword}
            onHide={() => setResetPassword(false)}
            closeModal={props.closeModal}
          />
        </Modal.Body>

        <Modal.Footer className="modal-footer no">
          <button
            type="submit"
            className="btn btn-block btn-danger font-weight-bold py-3 rounded f18"
          >
            Log in
            <img src="images/log-out.svg" className="ml-2" alt="" />
          </button>
          <div className="powered my-4 w-100">Powered by Warely</div>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

Step3.propTypes = {
  closeModal: PropTypes.func.isRequired,
  setCurrentUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
  login: state,
  loading: state.products.loading,
  user: state.auth.user,
});

export default withTranslation()(
  connect(mapStateToProps, { loginUser, setCurrentUser })(Step3)
);
